@if ((isEmpty$ | async)) {
  <div>
    <div [innerHTML]="(data | async)?.content" class="mr-1 no-products-container">
    </div>
  </div>
}